import { render, staticRenderFns } from "./ListingLavorazioni.vue?vue&type=template&id=2b520337"
import script from "./ListingLavorazioni.vue?vue&type=script&lang=js"
export * from "./ListingLavorazioni.vue?vue&type=script&lang=js"
import style0 from "./ListingLavorazioni.vue?vue&type=style&index=0&id=2b520337&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports